import React, {useEffect, useState} from 'react';
import Slider from "../components/home/Slider";
import CardSlider from "../components/home/CardSlider";
import AboutJidar from "../components/home/AboutSection";
import ProductsSection from "../components/home/ProductSection";
import {api} from "../api/api";

const Home = () => {
    const [homeData, setHomeData] = useState(null);
    useEffect(()=>{
        api.get('home').then(res=>{
            setHomeData(res.data)
            console.log(res.data)
        }).catch(err=>console.log(err))
    },[])

    return (
        <div>
            <Slider data={homeData?.slider || []}/>

            <div className="bg-[#f9f9f9] ">
                <CardSlider data={homeData?.Service || []}/>
            </div>
            <AboutJidar data={homeData?.about_us[0] || []}/>
            <ProductsSection data={homeData?.featured_products || []}/>
        </div>
    );
};

export default Home;